export const TYNEMCE = {
  API_KEY: '8tcgv8vqclsf5uhooax65dbbp0d4lbw0yvulc2wjwha7a1dp',
  PLUGINS: [
    'advlist autolink lists link image charmap print preview anchor',
    'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste code help wordcount',
  ],
  TOOLBAR: `undo redo | formatselect | bold italic backcolor |
    alignleft aligncenter alignright alignjustify |
    bullist numlist outdent indent | removeformat | help`,
};
